// import React, { useEffect, useState, useRef } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import {
//   Table,
//   Button,
//   Spinner,
//   Row,
//   Col,
//   Pagination,
//   Form,
// } from "react-bootstrap";
// import Swal from "sweetalert2";
// import { MdFilterAlt } from "react-icons/md";
// import { MdFilterAltOff } from "react-icons/md";
// import { FaCalendar, FaTimes } from "react-icons/fa";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

// const API_URL = process.env.REACT_APP_API_URL;
// const ITEMS_PER_PAGE = 10;
// function BlockedInactiveAssociatesCommissions() {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [loading, setLoading] = useState(false);
//   const [commissionData, setCommissionData] = useState([]);
//   const [totalItems, setTotalItems] = useState(0);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [filterName, setFilterName] = useState("");
//   const [filterMobile, setFilterMobile] = useState("");
//   const [filterLevel, setFilterLevel] = useState("");

//   const getAuthToken = () => localStorage.getItem("token");
//   const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
//   const [isFilterActive, setIsFilterActive] = useState(false);
//   const [filterFromDate, setFilterFromDate] = useState("");
//   const [filterToDate, setFilterToDate] = useState("");

//   const datePickerRef = useRef(null);
//   const handleIconClick = () => {
//     if (datePickerRef.current) {
//       datePickerRef.current.setOpen(true);
//     }
//   };

//   const handleClear = () => {
//     setFilterFromDate(null);
//   };

//   const handleToggle = () => {
//     setIsFilterActive(!isFilterActive);
//   };

//   const fetchParentCommission = async (page = 1) => {
//     setLoading(true);
//     try {
//       const token = getAuthToken();
//       if (!token) return;

//       const params = new URLSearchParams({
//         page,
//         limit: ITEMS_PER_PAGE,
//         source_direct_income_id: id,
//         associate_name: filterName,
//         associate_mobile: filterMobile,
//         level: filterLevel,
//         from_date: formatDateForServer(filterFromDate),
//         to_date: formatDateForServer(filterToDate),
//       });

//       const response = await fetch(
//         `${API_URL}/blocked-inactive-associates-commissions?${params}`,
//         {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       );

//       const data = await response.json();

//       if (data.success === 0 || !data.data || data.data.length === 0) {
//         setCommissionData([]);
//         setTotalItems(0);
//       } else {
//         setCommissionData(data.data);
//         setTotalItems(data.total || data.data.length);
//       }
//     } catch (error) {
//       console.error("Error fetching parent commission:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePageChange = (pageNum) => {
//     if (pageNum > 0 && pageNum <= totalPages) {
//       setCurrentPage(pageNum);
//     }
//   };

//   const handleFilter = () => {
//     setCurrentPage(1);
//     fetchParentCommission(1);
//   };

//   useEffect(() => {
//     fetchParentCommission(currentPage);
//   }, [currentPage]);

//   const formatDateForServer = (dateStr) => {
//     if (!dateStr) return "";

//     if (dateStr instanceof Date) {
//       const dd = String(dateStr.getDate()).padStart(2, "0");
//       const mm = String(dateStr.getMonth() + 1).padStart(2, "0");
//       const yyyy = dateStr.getFullYear();
//       return `${yyyy}-${mm}-${dd}`;
//     }

//     if (typeof dateStr === "string") {
//       const parts = dateStr.split("-");
//       if (parts.length !== 3) return "";
//       const [dd, mm, yyyy] = parts;
//       return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
//     }

//     return "";
//   };

//   // return (
//   //   <div className="card mt-2">
//   //     <div className="card-header gap-2 d-flex  justify-content-between align-items-md-center">
//   //       <div className="titlepage">
//   //         <h3 className="mb-0" style={{whiteSpace:"normal"}}>
//   //           Blocked Or Inactive Associates Commissions Details{" "}
//   //         </h3>
//   //       </div>
//   //       <div className="d-flex">
//   //         <button
//   //           className={`filter-toggle-btn btn ${isFilterActive ? "active" : ""}`}
//   //           onClick={handleToggle}
//   //         >
//   //           {isFilterActive ? (
//   //             <>
//   //               <MdFilterAltOff />
//   //             </>
//   //           ) : (
//   //             <>
//   //               <MdFilterAlt />
//   //             </>
//   //           )}
//   //         </button>
//   //       </div>
//   //     </div>

//   //     <div className="card-body">
//   //       {isFilterActive && (
//   //         <Row className="mb-3 gy-2">
//   //           <Col md={2}>
//   //             <div className="position-relative">
//   //               <div
//   //                 className="position-absolute"
//   //                 style={{ top: "10px", right: "20px" }}
//   //               >
//   //                 {!filterFromDate ? (
//   //                   <FaCalendar onClick={handleIconClick} />
//   //                 ) : (
//   //                   <FaTimes onClick={handleClear} />
//   //                 )}
//   //               </div>
//   //               <DatePicker
//   //                 ref={datePickerRef}
//   //                 selected={filterFromDate}
//   //                 onChange={(date) => setFilterFromDate(date)}
//   //                 placeholderText="DD-MM-YYYY"
//   //                 dateFormat="dd-MM-yyyy"
//   //                 className="form-control"
//   //                 showPopperArrow={false}
//   //               />
//   //             </div>
//   //           </Col>
//   //           <Col md={2}>
//   //             <div className="position-relative">
//   //               <div
//   //                 className="position-absolute"
//   //                 style={{ top: "10px", right: "20px" }}
//   //               >
//   //                 {!filterFromDate ? (
//   //                   <FaCalendar onClick={handleIconClick} />
//   //                 ) : (
//   //                   <FaTimes onClick={handleClear} />
//   //                 )}
//   //               </div>
//   //               <DatePicker
//   //                 selected={filterToDate}
//   //                 onChange={(date) => setFilterToDate(date)}
//   //                 placeholderText="DD-MM-YYYY"
//   //                 dateFormat="dd-MM-yyyy"
//   //                 className="form-control"
//   //                 showPopperArrow={false}
//   //               />
//   //             </div>
//   //           </Col>

//   //           <Col md={2} className="">
//   //             <Form.Control
//   //               type="text"
//   //               placeholder="Associate Name"
//   //               value={filterName}
//   //               onChange={(e) => setFilterName(e.target.value)}
//   //             />
//   //           </Col>
//   //           <Col md={2} className="">
//   //             <Form.Control
//   //               type="text"
//   //               placeholder="Associate Mobile"
//   //               value={filterMobile}
//   //               onChange={(e) => setFilterMobile(e.target.value)}
//   //             />
//   //           </Col>
//   //           <Col md={4}>
//   //             <div className="d-flex gap-2 align-items-center">
//   //               <Form.Control className="w-100"
//   //                 type="number"
//   //                 placeholder="Level"
//   //                 value={filterLevel}
//   //                 onChange={(e) => setFilterLevel(e.target.value)}
//   //               />
//   //               <Button variant="primary" onClick={handleFilter}>
//   //                 Apply Filter
//   //               </Button>
//   //             </div>
//   //           </Col>
//   //         </Row>
//   //       )}

//   //       {loading ? (
//   //         <div className="text-center my-5">
//   //           <Spinner animation="border" />
//   //         </div>
//   //       ) : (
//   //         <>
//   //           <div className="table-responsive">
//   //             <Table striped bordered hover>
//   //               <thead>
//   //                 <tr>
//   //                   <th>#</th>
//   //                   <th>Date</th>
//   //                   <th>Lead ID</th>
//   //                   <th>Customer Name</th>
//   //                   <th>Customer Mobile</th>
//   //                   <th>Associate Name</th>
//   //                   <th>Associate Mobile</th>
//   //                   <th>Amount</th>
//   //                 </tr>
//   //               </thead>
//   //               <tbody>
//   //                 {commissionData.length === 0 ? (
//   //                   <tr>
//   //                     <td colSpan="11" className="text-center text-muted py-4">
//   //                       No data found.
//   //                     </td>
//   //                   </tr>
//   //                 ) : (
//   //                   commissionData.map((record, idx) => (
//   //                     <tr key={record.id}>
//   //                       <td>{(currentPage - 1) * ITEMS_PER_PAGE + idx + 1}</td>
//   //                       <td>
//   //                         {record.date
//   //                           ? `${new Date(record.date).getDate().toString().padStart(2, "0")}-${(
//   //                               new Date(record.date).getMonth() + 1
//   //                             )
//   //                               .toString()
//   //                               .padStart(
//   //                                 2,
//   //                                 "0",
//   //                               )}-${new Date(record.date).getFullYear()}`
//   //                           : ""}
//   //                       </td>
//   //                       <td>{record.lead_id || "N/A"}</td>
//   //                       <td>
//   //                         {record.customer_name
//   //                           ? record.customer_name.charAt(0).toUpperCase() +
//   //                             record.customer_name.slice(1).toLowerCase()
//   //                           : ""}
//   //                       </td>
//   //                       <td>{record.customer_mobile}</td>
//   //                       <td>{record.associate_name}</td>
//   //                       <td>{record.associate_mobile}</td>
//   //                       <td>{record.payable_amount}</td>
//   //                     </tr>
//   //                   ))
//   //                 )}
//   //               </tbody>
//   //             </Table>
//   //           </div>
//   //           {totalPages > 1 && commissionData.length > 0 && (
//   //             <div className="d-flex justify-content-end mt-4">
//   //               <Pagination>
//   //                 <Pagination.Prev
//   //                   onClick={() => handlePageChange(currentPage - 1)}
//   //                   disabled={currentPage === 1}
//   //                 />
//   //                 {[...Array(totalPages)].map((_, i) => (
//   //                   <Pagination.Item
//   //                     key={i + 1}
//   //                     active={i + 1 === currentPage}
//   //                     onClick={() => handlePageChange(i + 1)}
//   //                   >
//   //                     {i + 1}
//   //                   </Pagination.Item>
//   //                 ))}
//   //                 <Pagination.Next
//   //                   onClick={() => handlePageChange(currentPage + 1)}
//   //                   disabled={currentPage === totalPages}
//   //                 />
//   //               </Pagination>
//   //             </div>
//   //           )}
//   //         </>
//   //       )}
//   //     </div>
//   //   </div>
//   // );
//   return (
//     <>
//       <div
//         style={{
//           minHeight: "100vh",
//           background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
//           padding: "30px 24px",
//           fontFamily: "'Poppins', 'DM Sans', sans-serif",
//         }}
//       >
//         <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//           {/* 🎯 HEADER CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               padding: "20px 24px",
//               display: "flex",
//               alignItems: "center",
//               gap: "16px",
//               marginBottom: "20px",
//               flexWrap: "wrap",
//             }}
//           >
//             <div
//               style={{
//                 width: "52px",
//                 height: "52px",
//                 borderRadius: "14px",
//                 background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 color: "#ffffff",
//                 fontSize: "24px",
//                 boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
//                 flexShrink: 0,
//               }}
//             >
//               🚫
//             </div>
//             <div style={{ flex: 1, minWidth: "200px" }}>
//               <h1
//                 style={{
//                   margin: 0,
//                   fontSize: "22px",
//                   fontWeight: "800",
//                   color: "#1e3a5f",
//                   letterSpacing: "-0.5px",
//                   lineHeight: 1.3,
//                 }}
//               >
//                 Blocked Or Inactive Associates Commissions Details
//               </h1>
//               <p
//                 style={{
//                   margin: "2px 0 0",
//                   fontSize: "13px",
//                   color: "#64748b",
//                   fontWeight: "500",
//                 }}
//               >
//                 Detailed commission records for blocked/inactive associates
//               </p>
//             </div>

//             {/* Filter Toggle */}
//             <button
//               className={`filter-toggle-btn btn ${isFilterActive ? "active" : ""}`}
//               onClick={handleToggle}
//               style={{
//                 width: "44px",
//                 height: "44px",
//                 borderRadius: "12px",
//                 border: "1.5px solid #e2e8f0",
//                 background: isFilterActive ? "#1e5799" : "#ffffff",
//                 color: isFilterActive ? "#ffffff" : "#1e3a5f",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontSize: "20px",
//                 cursor: "pointer",
//                 transition: "all 0.25s ease",
//                 boxShadow: isFilterActive
//                   ? "0 8px 20px rgba(30, 87, 153, 0.3)"
//                   : "none",
//               }}
//               title={isFilterActive ? "Hide Filters" : "Show Filters"}
//             >
//               {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
//             </button>
//           </div>

//           {/* 🎯 MAIN CARD */}
//           <div
//             style={{
//               background: "#ffffff",
//               borderRadius: "16px",
//               boxShadow: "0 8px 24px rgba(30, 87, 153, 0.08)",
//               border: "1.5px solid #e2e8f0",
//               overflow: "hidden",
//             }}
//           >
//             <div
//               style={{
//                 height: "5px",
//                 background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
//               }}
//             />

//             <div style={{ padding: "30px" }}>
//               {/* 🎯 FILTER PANEL */}
//               {isFilterActive && (
//                 <div
//                   style={{
//                     background: "#f8fafc",
//                     border: "1.5px dashed #cbd5e1",
//                     borderRadius: "12px",
//                     padding: "20px",
//                     marginBottom: "24px",
//                   }}
//                 >
//                   <Row className="gy-3">
//                     <Col md={6} lg={3}>
//                       <div className="position-relative">
//                         <div
//                           className="position-absolute"
//                           style={{
//                             top: "10px",
//                             right: "20px",
//                             zIndex: 2,
//                             cursor: "pointer",
//                           }}
//                         >
//                           {!filterFromDate ? (
//                             <FaCalendar onClick={handleIconClick} />
//                           ) : (
//                             <FaTimes onClick={handleClear} />
//                           )}
//                         </div>
//                         <DatePicker
//                           ref={datePickerRef}
//                           selected={filterFromDate}
//                           onChange={(date) => setFilterFromDate(date)}
//                           placeholderText="From Date (DD-MM-YYYY)"
//                           dateFormat="dd-MM-yyyy"
//                           className="form-control"
//                           showPopperArrow={false}
//                         />
//                       </div>
//                     </Col>

//                     <Col md={6} lg={3}>
//                       <div className="position-relative">
//                         <DatePicker
//                           selected={filterToDate}
//                           onChange={(date) => setFilterToDate(date)}
//                           placeholderText="To Date (DD-MM-YYYY)"
//                           dateFormat="dd-MM-yyyy"
//                           className="form-control"
//                           showPopperArrow={false}
//                         />
//                       </div>
//                     </Col>

//                     <Col md={6} lg={2}>
//                       <Form.Control
//                         type="text"
//                         placeholder="Associate Name"
//                         value={filterName}
//                         onChange={(e) => setFilterName(e.target.value)}
//                       />
//                     </Col>

//                     <Col md={6} lg={2}>
//                       <Form.Control
//                         type="text"
//                         placeholder="Associate Mobile"
//                         value={filterMobile}
//                         onChange={(e) => setFilterMobile(e.target.value)}
//                       />
//                     </Col>

//                     <Col md={6} lg={2}>
//                       <Form.Control
//                         type="number"
//                         placeholder="Level"
//                         value={filterLevel}
//                         onChange={(e) => setFilterLevel(e.target.value)}
//                       />
//                     </Col>

//                     <Col md={12} lg={12}>
//                       <div className="d-flex gap-2 justify-content-end align-items-center">
//                         <Button variant="primary" onClick={handleFilter}>
//                           Apply Filter
//                         </Button>
//                       </div>
//                     </Col>
//                   </Row>
//                 </div>
//               )}

//               {/* 🎯 TABLE */}
//               {loading ? (
//                 <div className="text-center my-5">
//                   <Spinner animation="border" />
//                 </div>
//               ) : (
//                 <>
//                   <div className="table-responsive">
//                     <Table striped bordered hover>
//                       <thead>
//                         <tr>
//                           <th>#</th>
//                           <th>Date</th>
//                           <th>Lead ID</th>
//                           <th>Customer Name</th>
//                           <th>Customer Mobile</th>
//                           <th>Associate Name</th>
//                           <th>Associate Mobile</th>
//                           <th>Amount</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {commissionData.length === 0 ? (
//                           <tr>
//                             <td
//                               colSpan="8"
//                               className="text-center text-muted py-4"
//                             >
//                               No data found.
//                             </td>
//                           </tr>
//                         ) : (
//                           commissionData.map((record, idx) => (
//                             <tr key={record.id}>
//                               <td>
//                                 {(currentPage - 1) * ITEMS_PER_PAGE + idx + 1}
//                               </td>
//                               <td>
//                                 {record.date
//                                   ? `${new Date(record.date)
//                                       .getDate()
//                                       .toString()
//                                       .padStart(2, "0")}-${(
//                                       new Date(record.date).getMonth() + 1
//                                     )
//                                       .toString()
//                                       .padStart(2, "0")}-${new Date(
//                                       record.date,
//                                     ).getFullYear()}`
//                                   : ""}
//                               </td>
//                               <td>{record.lead_id || "N/A"}</td>
//                               <td>
//                                 {record.customer_name
//                                   ? record.customer_name
//                                       .charAt(0)
//                                       .toUpperCase() +
//                                     record.customer_name.slice(1).toLowerCase()
//                                   : ""}
//                               </td>
//                               <td>{record.customer_mobile}</td>
//                               <td>{record.associate_name}</td>
//                               <td>{record.associate_mobile}</td>
//                               <td>{record.payable_amount}</td>
//                             </tr>
//                           ))
//                         )}
//                       </tbody>
//                     </Table>
//                   </div>

//                   {/* 🎯 PAGINATION */}
//                   {totalPages > 1 && commissionData.length > 0 && (
//                     <div className="d-flex justify-content-end mt-4">
//                       <Pagination>
//                         <Pagination.Prev
//                           onClick={() => handlePageChange(currentPage - 1)}
//                           disabled={currentPage === 1}
//                         />
//                         {[...Array(totalPages)].map((_, i) => (
//                           <Pagination.Item
//                             key={i + 1}
//                             active={i + 1 === currentPage}
//                             onClick={() => handlePageChange(i + 1)}
//                           >
//                             {i + 1}
//                           </Pagination.Item>
//                         ))}
//                         <Pagination.Next
//                           onClick={() => handlePageChange(currentPage + 1)}
//                           disabled={currentPage === totalPages}
//                         />
//                       </Pagination>
//                     </div>
//                   )}
//                 </>
//               )}
//             </div>
//           </div>

//           {/* Footer Copyright */}
//           <p
//             style={{
//               textAlign: "center",
//               color: "#94a3b8",
//               fontSize: "12.5px",
//               marginTop: "24px",
//               fontWeight: "500",
//             }}
//           >
//             © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
//             Rights Reserved.
//           </p>
//         </div>
//       </div>
//     </>
//   );
  

// }

// export default BlockedInactiveAssociatesCommissions;

import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Form, Row, Col, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { MdFilterAlt, MdFilterAltOff } from "react-icons/md";
import { FaCalendar, FaTimes } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const API_URL = process.env.REACT_APP_API_URL;
const ITEMS_PER_PAGE = 10;

function BlockedInactiveAssociatesCommissions() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [commissionData, setCommissionData] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [isFilterActive, setIsFilterActive] = useState(false);

  const [filterName, setFilterName] = useState("");
  const [filterMobile, setFilterMobile] = useState("");
  const [filterLevel, setFilterLevel] = useState("");
  const [filterFromDate, setFilterFromDate] = useState(null);
  const [filterToDate, setFilterToDate] = useState(null);

  const datePickerRef = useRef(null);

  const getAuthToken = () => localStorage.getItem("token");

  const totalPages = Math.max(1, Math.ceil(totalItems / ITEMS_PER_PAGE));

  const handleToggle = () => setIsFilterActive(!isFilterActive);

  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  const handleClearFromDate = () => setFilterFromDate(null);
  const handleClearToDate = () => setFilterToDate(null);

  // ═══════════════════════════════════════════
  // 🔹 FORMAT DATE
  // ═══════════════════════════════════════════
  const formatDateForServer = (dateStr) => {
    if (!dateStr) return "";
    if (dateStr instanceof Date) {
      const dd = String(dateStr.getDate()).padStart(2, "0");
      const mm = String(dateStr.getMonth() + 1).padStart(2, "0");
      const yyyy = dateStr.getFullYear();
      return `${yyyy}-${mm}-${dd}`;
    }
    return "";
  };

  // ═══════════════════════════════════════════
  // 🔹 FETCH COMMISSIONS (Server-Side Pagination)
  // ═══════════════════════════════════════════
  const fetchParentCommission = async (page = 1) => {
    setLoading(true);
    try {
      const token = getAuthToken();
      if (!token) {
        setLoading(false);
        return;
      }

      const params = new URLSearchParams({
        page,
        limit: ITEMS_PER_PAGE,
        source_direct_income_id: id,
        associate_name: filterName,
        associate_mobile: filterMobile,
        level: filterLevel,
        from_date: formatDateForServer(filterFromDate),
        to_date: formatDateForServer(filterToDate),
      });

      const response = await fetch(
        `${API_URL}/blocked-inactive-associates-commissions?${params}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();

      if (data.success === 0 || !data.data || data.data.length === 0) {
        setCommissionData([]);
        setTotalItems(0);
      } else {
        setCommissionData(data.data);
        const total = Number(data.total) || data.data.length || 0;
        setTotalItems(total);
      }
    } catch (error) {
      console.error("Error fetching parent commission:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchParentCommission(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const handlePageChange = (pageNum) => {
    if (pageNum < 1 || pageNum > totalPages) return;
    setCurrentPage(pageNum);
  };

  const handleFilter = () => {
    setCurrentPage(1);
    fetchParentCommission(1);
  };

  const handleClearFilters = () => {
    setFilterName("");
    setFilterMobile("");
    setFilterLevel("");
    setFilterFromDate(null);
    setFilterToDate(null);
    setCurrentPage(1);
    setTimeout(() => fetchParentCommission(1), 0);
  };

  // ═══════════════════════════════════════════
  // 🔹 PAGINATION PAGES
  // ═══════════════════════════════════════════
  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;

    pages.push(1);
    if (showEllipsis && currentPage > 4) pages.push("left-ellipsis");

    const start = Math.max(2, currentPage - 2);
    const end = Math.min(totalPages - 1, currentPage + 2);

    for (let i = start; i <= end; i++) pages.push(i);

    if (showEllipsis && currentPage < totalPages - 3) pages.push("right-ellipsis");
    if (totalPages > 1) pages.push(totalPages);

    return pages;
  };

  // ═══════════════════════════════════════════
  // 🎨 UI RENDER
  // ═══════════════════════════════════════════
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
        padding: "24px",
        fontFamily: "'Poppins', 'DM Sans', sans-serif",
      }}
    >
      <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
        <div
          style={{
            background: "#ffffff",
            borderRadius: "20px",
            boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
            border: "1.5px solid #e2e8f0",
            overflow: "hidden",
          }}
        >
          {/* Top Gradient */}
          <div
            style={{
              height: "5px",
              background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
            }}
          />

          {/* Header */}
          <div
            style={{
              padding: "24px 30px",
              background: "linear-gradient(135deg, #ffffff, #f8fafc)",
              borderBottom: "1.5px solid #e2e8f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px",
              flexWrap: "wrap",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "14px",
                  background: "linear-gradient(135deg, #dc2626, #b91c1c)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#ffffff",
                  fontSize: "22px",
                  boxShadow: "0 8px 20px rgba(220, 38, 38, 0.3)",
                  flexShrink: 0,
                }}
              >
                🚫
              </div>
              <div>
                <h2
                  style={{
                    margin: 0,
                    fontSize: "22px",
                    fontWeight: "800",
                    color: "#1e3a5f",
                    lineHeight: 1.3,
                  }}
                >
                  Blocked / Inactive Associates Commissions
                </h2>
                <p
                  style={{
                    margin: "2px 0 0",
                    fontSize: "12.5px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  Detailed commission records ({totalItems} total)
                </p>
              </div>
            </div>

            <button
              onClick={handleToggle}
              style={{
                width: "42px",
                height: "42px",
                borderRadius: "10px",
                border: isFilterActive ? "none" : "1.5px solid #e2e8f0",
                background: isFilterActive
                  ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                  : "#ffffff",
                color: isFilterActive ? "#ffffff" : "#1e5799",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "18px",
                cursor: "pointer",
                boxShadow: isFilterActive
                  ? "0 6px 18px rgba(30, 87, 153, 0.3)"
                  : "none",
              }}
              title="Toggle Filters"
            >
              {isFilterActive ? <MdFilterAltOff /> : <MdFilterAlt />}
            </button>
          </div>

          {/* Body */}
          <div style={{ padding: "24px 30px" }}>
            {/* Filters */}
            {isFilterActive && (
              <div
                style={{
                  background: "#f8fafc",
                  borderRadius: "14px",
                  padding: "18px",
                  marginBottom: "24px",
                  border: "1.5px solid #e2e8f0",
                }}
              >
                <Row className="gy-3">
                  <Col md={6} lg={3}>
                    <label style={labelStyle}>From Date</label>
                    <div style={{ position: "relative" }}>
                      <div
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "12px",
                          zIndex: 2,
                          cursor: "pointer",
                          color: "#1e5799",
                        }}
                      >
                        {!filterFromDate ? (
                          <FaCalendar onClick={handleIconClick} />
                        ) : (
                          <FaTimes onClick={handleClearFromDate} />
                        )}
                      </div>
                      <DatePicker
                        ref={datePickerRef}
                        selected={filterFromDate}
                        onChange={(date) => setFilterFromDate(date)}
                        placeholderText="DD-MM-YYYY"
                        dateFormat="dd-MM-yyyy"
                        className="form-control"
                        showPopperArrow={false}
                        style={inputStyle}
                      />
                    </div>
                  </Col>

                  <Col md={6} lg={3}>
                    <label style={labelStyle}>To Date</label>
                    <div style={{ position: "relative" }}>
                      <div
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "12px",
                          zIndex: 2,
                          cursor: "pointer",
                          color: "#1e5799",
                        }}
                      >
                        {!filterToDate ? (
                          <FaCalendar />
                        ) : (
                          <FaTimes onClick={handleClearToDate} />
                        )}
                      </div>
                      <DatePicker
                        selected={filterToDate}
                        onChange={(date) => setFilterToDate(date)}
                        placeholderText="DD-MM-YYYY"
                        dateFormat="dd-MM-yyyy"
                        className="form-control"
                        showPopperArrow={false}
                      />
                    </div>
                  </Col>

                  <Col md={6} lg={2}>
                    <label style={labelStyle}>Associate Name</label>
                    <input
                      type="text"
                      placeholder="Associate Name"
                      value={filterName}
                      onChange={(e) => setFilterName(e.target.value)}
                      style={inputStyle}
                    />
                  </Col>

                  <Col md={6} lg={2}>
                    <label style={labelStyle}>Associate Mobile</label>
                    <input
                      type="text"
                      placeholder="Associate Mobile"
                      value={filterMobile}
                      onChange={(e) => setFilterMobile(e.target.value)}
                      style={inputStyle}
                    />
                  </Col>

                  <Col md={6} lg={2}>
                    <label style={labelStyle}>Level</label>
                    <input
                      type="number"
                      placeholder="Level"
                      value={filterLevel}
                      onChange={(e) => setFilterLevel(e.target.value)}
                      style={inputStyle}
                    />
                  </Col>

                  <Col md={12}>
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <button
                        onClick={handleClearFilters}
                        style={{
                          padding: "10px 22px",
                          borderRadius: "10px",
                          border: "1.5px solid #e2e8f0",
                          background: "#ffffff",
                          color: "#64748b",
                          fontSize: "13px",
                          fontWeight: "700",
                          cursor: "pointer",
                        }}
                      >
                        Clear
                      </button>
                      <button
                        onClick={handleFilter}
                        style={{
                          padding: "10px 22px",
                          borderRadius: "10px",
                          border: "none",
                          background:
                            "linear-gradient(135deg, #1e5799, #2b6cb0)",
                          color: "#ffffff",
                          fontSize: "13px",
                          fontWeight: "700",
                          cursor: "pointer",
                          boxShadow: "0 6px 18px rgba(30, 87, 153, 0.3)",
                        }}
                      >
                        Apply Filter
                      </button>
                    </div>
                  </Col>
                </Row>
              </div>
            )}

            {/* Table */}
            {loading ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "60px 20px",
                  color: "#64748b",
                }}
              >
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    border: "3px solid #cbd5e1",
                    borderTop: "3px solid #2b6cb0",
                    borderRadius: "50%",
                    display: "inline-block",
                    animation: "spin 0.8s linear infinite",
                  }}
                />
                <p
                  style={{
                    marginTop: "16px",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  Loading commissions...
                </p>
              </div>
            ) : commissionData.length === 0 ? (
              <div
                style={{
                  textAlign: "center",
                  padding: "50px",
                  color: "#94a3b8",
                  fontWeight: "600",
                }}
              >
                📭 No data found.
              </div>
            ) : (
              <>
                <div
                  style={{
                    overflowX: "auto",
                    overflowY: "visible",
                    borderRadius: "14px",
                    border: "1.5px solid #e2e8f0",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      minWidth: "1100px",
                      borderCollapse: "collapse",
                      fontSize: "13px",
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          background:
                            "linear-gradient(135deg, #1e5799, #2b6cb0)",
                        }}
                      >
                        {[
                          "S.N",
                          "Date",
                          "Lead ID",
                          "Customer Name",
                          "Customer Mobile",
                          "Associate Name",
                          "Associate Mobile",
                          "Amount",
                        ].map((th, i) => (
                          <th
                            key={i}
                            style={{
                              padding: "14px 12px",
                              color: "#ffffff",
                              fontWeight: "700",
                              fontSize: "11.5px",
                              textAlign: "left",
                              letterSpacing: "0.5px",
                              textTransform: "uppercase",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {th}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {commissionData.map((record, idx) => (
                        <tr
                          key={record.id}
                          style={{ borderBottom: "1px solid #f1f5f9" }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.background = "#f8fafc")
                          }
                          onMouseLeave={(e) =>
                            (e.currentTarget.style.background = "transparent")
                          }
                        >
                          <td style={cellBlue}>
                            {(currentPage - 1) * ITEMS_PER_PAGE + idx + 1}
                          </td>
                          <td style={{ ...cellGray, whiteSpace: "nowrap" }}>
                            {record.date
                              ? (() => {
                                  const d = new Date(record.date);
                                  const day = String(d.getDate()).padStart(
                                    2,
                                    "0"
                                  );
                                  const month = String(
                                    d.getMonth() + 1
                                  ).padStart(2, "0");
                                  const year = d.getFullYear();
                                  return `${day}-${month}-${year}`;
                                })()
                              : "-"}
                          </td>
                          <td style={cellText}>{record.lead_id || "N/A"}</td>
                          <td style={cellDark}>
                            {record.customer_name
                              ? record.customer_name
                                  .charAt(0)
                                  .toUpperCase() +
                                record.customer_name.slice(1).toLowerCase()
                              : "-"}
                          </td>
                          <td style={cellGray}>
                            {record.customer_mobile || "-"}
                          </td>
                          <td style={cellDark}>
                            {record.associate_name || "-"}
                          </td>
                          <td style={cellGray}>
                            {record.associate_mobile || "-"}
                          </td>
                          <td
                            style={{
                              padding: "12px",
                              fontWeight: "700",
                              color: "#dc2626",
                              whiteSpace: "nowrap",
                            }}
                          >
                            ₹{" "}
                            {Number(record.payable_amount || 0).toLocaleString(
                              "en-IN",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "24px",
                      gap: "6px",
                      flexWrap: "wrap",
                    }}
                  >
                    <button
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                      style={{
                        padding: "8px 14px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color: currentPage === 1 ? "#cbd5e1" : "#1e5799",
                        fontWeight: "700",
                        fontSize: "13px",
                        cursor: currentPage === 1 ? "not-allowed" : "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      ‹ Prev
                    </button>

                    {getPageNumbers().map((p, i) => {
                      if (p === "left-ellipsis" || p === "right-ellipsis") {
                        return (
                          <span
                            key={`ellipsis-${i}`}
                            style={{
                              padding: "0 6px",
                              color: "#94a3b8",
                              fontWeight: "700",
                            }}
                          >
                            ...
                          </span>
                        );
                      }
                      const isActive = p === currentPage;
                      return (
                        <button
                          key={p}
                          onClick={() => handlePageChange(p)}
                          style={{
                            minWidth: "38px",
                            height: "38px",
                            borderRadius: "10px",
                            border: isActive
                              ? "none"
                              : "1.5px solid #e2e8f0",
                            background: isActive
                              ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                              : "#ffffff",
                            color: isActive ? "#ffffff" : "#334155",
                            fontWeight: "700",
                            fontSize: "13px",
                            cursor: "pointer",
                            boxShadow: isActive
                              ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                              : "none",
                            transition: "all 0.18s ease",
                          }}
                        >
                          {p}
                        </button>
                      );
                    })}

                    <button
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                      style={{
                        padding: "8px 14px",
                        borderRadius: "10px",
                        border: "1.5px solid #e2e8f0",
                        background: "#ffffff",
                        color:
                          currentPage === totalPages ? "#cbd5e1" : "#1e5799",
                        fontWeight: "700",
                        fontSize: "13px",
                        cursor:
                          currentPage === totalPages
                            ? "not-allowed"
                            : "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      Next ›
                    </button>
                  </div>
                )}

                {totalItems > 0 && (
                  <p
                    style={{
                      textAlign: "center",
                      fontSize: "12px",
                      color: "#94a3b8",
                      marginTop: "12px",
                      marginBottom: 0,
                      fontWeight: "500",
                    }}
                  >
                    Page {currentPage} of {totalPages} • {totalItems} total
                    records
                  </p>
                )}
              </>
            )}
          </div>
        </div>

        {/* Footer */}
        <p
          style={{
            textAlign: "center",
            color: "#94a3b8",
            fontSize: "12.5px",
            marginTop: "24px",
            fontWeight: "500",
          }}
        >
          © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All Rights
          Reserved.
        </p>
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

// ═══════════════════════════════════════════
// 🎨 SHARED STYLES
// ═══════════════════════════════════════════
const labelStyle = {
  display: "block",
  fontSize: "12.5px",
  fontWeight: "700",
  color: "#1e3a5f",
  marginBottom: "6px",
};

const inputStyle = {
  width: "100%",
  padding: "10px 14px",
  borderRadius: "10px",
  border: "1.5px solid #e2e8f0",
  fontSize: "13.5px",
  fontWeight: "500",
  color: "#1e3a5f",
  outline: "none",
  boxSizing: "border-box",
};

const cellBlue = { padding: "12px", fontWeight: "700", color: "#1e5799" };
const cellDark = { padding: "12px", fontWeight: "600", color: "#1e3a5f" };
const cellGray = { padding: "12px", color: "#64748b" };
const cellText = { padding: "12px", fontWeight: "600", color: "#1e5799" };

export default BlockedInactiveAssociatesCommissions;
